import React from 'react'
import { Link } from 'react-router-dom'
import { HiArrowRight } from 'react-icons/hi';
import { Player } from '@lottiefiles/react-lottie-player';
import animation from '../../../assets/images/404.json'


function Error() {
		return (
			<section className="h-screen bg-[#F1F1F4] w-full">
				<div className="container mx-auto flex items-center justify-center h-[80vh]">
					<div className="flex flex-col items-center justify-center">

						<Player
							src={animation}
							className="player h-[166px] w-[383px]"
							loop
							autoplay
							speed={3}
						/>
						<h3 className="font-sfprobold text-black leading-[36px] text-3xl w-[404px] text-center font-extrabold py-12">Sorry, we could’nt find the page you’re looking for</h3>
						<Link to="/" className='px-4 py-6 rounded-[600px] bg-black text-base flex items-center justify-center w-[220px]'>
							<span className={`text-white font-semibold font-sfprobold `}>Return to homepage</span>
							<HiArrowRight size={25} className={"ml-2 text-white"} />
						</Link>
					</div>

				</div>
				
				</section>
		)
}

export default Error